import { ICaptionsItem } from '../../../../../../types/common';
import { AppThunk } from '../../../../../../store/types';
import { PlayerController } from '../../../../../../effects/player/manager/playerController';
import { EShortcutsListenerContainer, setShortcutsListenerContainer } from '../../../../../../effects/shortcutsListener';
import { AudioPlayerManager } from '../../../../../../effects/audioPlayer/audioPlayerManager';
import { isHoverAutoPause } from '../../../../../../store/general/selectors';

export class TargetAudioCaptionsEvents {

  public static onCaptionDblClick(index: number, caption: ICaptionsItem): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      AudioPlayerManager.getInstance().play(caption.startTime);
    }
  };

  public static onCaptionPlay(caption: ICaptionsItem, isPause?: boolean): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (isPause) {
        AudioPlayerManager.getInstance().pause();
      } else {
        const time = AudioPlayerManager.getInstance().getCurrentTime();
        let start = caption.startTime;
        if (time &&
          caption.startTime < time &&
          caption.endTime > time
        ) {
          start = time;
        }
        AudioPlayerManager.getInstance().play(start);
      }
      setShortcutsListenerContainer(EShortcutsListenerContainer.CAPTIONS);
    }
  }

  public static onCaptionMouseDown(): AppThunk {
    return (
      dispatch,
      getState
    ) => {

      if (AudioPlayerManager.getInstance().isPlayerActive()) {
        AudioPlayerManager.getInstance().pause();
      }
    }
  }

  public static onMouseLeave(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (!isHoverAutoPause(getState())) return;
      PlayerController.getInstance().mouseLeave();
    }
  }

  public static onMouseEnter(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (!isHoverAutoPause(getState())) return;
      PlayerController.getInstance().mouseEnter();
    }
  }

}
